import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {  getLendersSuccess, 
          getLendersFailure,
          getLenderSuccess,
          getLenderFailure} from './actions';
import { GET_LENDERS,GET_LENDER } from './constants';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

// Get Lenders
function* getLendersSaga() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetLenderDashboard`, options);
    yield put(getLendersSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = error.description || 'An error occurred';
    }
    yield put(getLendersFailure(message));
  }
}

// Get Lenders
function* getLenderSaga({ payload: { lenderId } }) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetLenderDetails/${lenderId}`, options);
    yield put(getLenderSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = error.description || 'An error occurred';
    }
    yield put(getLenderFailure(message));
  }
}

/**
 * Watchers
 */
export function* watchGetLenders() {
  yield takeEvery(GET_LENDERS, getLendersSaga);
}
export function* watchGetLender() {
  yield takeEvery(GET_LENDER, getLenderSaga);
}

function* LendersSaga() {
  yield all([
    fork(watchGetLenders),
    fork(watchGetLender),
  ]);
}

export default LendersSaga;
